import React, { Component } from 'react';
import './MeteringNavBar.css';
import { Link } from 'react-router-dom';


class MeteringNavBar extends Component {
  render() {
    return (
      <div className="metering-nav-bar" style={{padding: '10px 36px'}}>
        <div className="nav-container">
          <div className={`nav-link ${window.location.pathname.startsWith('/devices') ? 'selected' : ''}`}>
            <Link id="devices" to="/devices">Devices</Link>
          </div>
          <div className={`nav-link ${window.location.pathname.startsWith('/transactions') ? 'selected' : ''}`}>
            <Link id="transactions" to="/transactions">Transactions (&#946;eta)</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default MeteringNavBar;
